import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "@/pages/Login";
import Calculator from "@/pages/Calculator";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Toaster } from "@/components/ui/sonner";
import { api } from "@/lib/api";

function useAuthCheck(endpoint) {
  const [state, setState] = useState({ loading: true, authed: false });
  useEffect(() => {
    let mounted = true;
    api
      .get(endpoint)
      .then((res) => {
        if (mounted) setState({ loading: false, authed: !!res.data?.authenticated });
      })
      .catch(() => {
        if (mounted) setState({ loading: false, authed: false });
      });
    return () => {
      mounted = false;
    };
  }, [endpoint]);
  return state;
}

function LoadingScreen({ testid }) {
  return (
    <div
      data-testid={testid}
      className="min-h-screen flex items-center justify-center"
      style={{ background: "#0a0a0a", color: "#fff" }}
    >
      <div className="text-sm opacity-70">Lade…</div>
    </div>
  );
}

function ProtectedUserRoute({ children }) {
  const { loading, authed } = useAuthCheck("/auth/me");
  if (loading) return <LoadingScreen testid="auth-loading" />;
  if (!authed) return <Navigate to="/" replace />;
  return children;
}

function ProtectedAdminRoute({ children }) {
  const { loading, authed } = useAuthCheck("/admin/me");
  if (loading) return <LoadingScreen testid="admin-auth-loading" />;
  if (!authed) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/calculator"
            element={
              <ProtectedUserRoute>
                <Calculator />
              </ProtectedUserRoute>
            }
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminDashboard />
              </ProtectedAdminRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" theme="dark" />
    </div>
  );
}

export default App;
